import React, { createContext, useContext, useState, useCallback } from 'react';

const PlayerContext = createContext(null);

const INITIAL_PROGRESS_PERCENT = 38;
const INITIAL_VOLUME_PERCENT = 75;
const PROGRESS_RESET = 0;

export const PlayerProvider = ({ children }) => {
  const [current, setCurrent] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [queue, setQueue] = useState([]);
  const [progress, setProgress] = useState(INITIAL_PROGRESS_PERCENT);
  const [volume, setVolume] = useState(INITIAL_VOLUME_PERCENT);

  const play = useCallback((track) => {
    setCurrent(track);
    setIsPlaying(true);
    setProgress(PROGRESS_RESET);
  }, []);

  const togglePlay = useCallback(() => {
    if (!current) return;
    setIsPlaying((p) => !p);
  }, [current]);

  const addToQueue = useCallback((track) => {
    setQueue((q) => [...q, track]);
  }, []);

  const value = {
    current,
    isPlaying,
    queue,
    progress,
    volume,
    setProgress,
    setVolume,
    play,
    togglePlay,
    addToQueue,
  };

  return <PlayerContext.Provider value={value}>{children}</PlayerContext.Provider>;
};

export const usePlayer = () => {
  const ctx = useContext(PlayerContext);
  if (!ctx) throw new Error('usePlayer must be used within PlayerProvider');
  return ctx;
};
